import { PageState } from "./ItemListPageState";

export const initialPageState: PageState = {
  categoryId: null,
  products: [],
};
